export default function CallToAction() {
  return (
    <div className="flex flex-wrap gap-md" style={{ marginTop: 'var(--spacing-xl)' }}>
      <a href="#availability" className="btn btn-primary">
        Descargar ahora
      </a>
      <a href="#contact" className="btn btn-secondary">
        Regístrate para más información
      </a>
    </div>
  )
} 